import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getOverdueServices } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const OverdueServicesReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();

  const chartConfig = {
    id: 'overdue-services',
    title: t("title.overdueEntity", { entity: customCaptions?.servicePlural }),
    fetchData: async (params) => {
      return await getOverdueServices(params);
    },
    allowedChartTypes: ['pie', 'vertical-bar'],
    defaultChartType: 'pie',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: t("label.count")
      }]
    },
    series: [
      { 
        label: t("label.count"),
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    viewData: '/app/services',
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: t("label.count") 
        }]
      },
      series: [
        { 
          label: t("label.count"),
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      breadcrumbLabel: t("label.entityCount", { entity: customCaptions?.model || 'Model' }),
      getParams: (dataPoint) => {
        return {
          roleId: dataPoint.id,
          role: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={t("title.overdueEntity", { entity: customCaptions?.servicePlural })}
      chartConfig={chartConfig}
    />
  );
};

export default OverdueServicesReport; 
